import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { REGISTRATION_REQUEST_CLEAN } from '../../../actions/registration.action';
import { LOGIN_REQUEST_CLEAN } from '../../../actions/login.action';

@Component({
  selector: 'consentz-error',
  templateUrl: './error.template.html',
  styleUrls: ['./error.styles.scss']
})
export class ErrorComponent implements OnDestroy {
  public currentBookingOptions = localStorage.getItem('currentBookingOptions') !== 'null' && JSON.parse(localStorage.getItem('currentBookingOptions'));


  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ErrorComponent>,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.type === 'registration') {
      this.store.dispatch({
        type: REGISTRATION_REQUEST_CLEAN,
        payload: {
          data: null,
          error: null
        }
      });
    }
    if (data.type === 'login') {
      this.store.dispatch({
        type: LOGIN_REQUEST_CLEAN,
        payload: {
          data: null,
          error: null
        }
      });
    }
  }

  public ngOnDestroy(): void {}
  public goHome(): void {
    this.router.navigate([localStorage.getItem('AppId') + '/home']);
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/popups/error/error.component.ts